export const fallbackLng = 'en';
export const languages = ['en', 'tr', 'fr', 'vi', 'cn', 'ar']; // Added 'tr' for Turkish
export const defaultNS = 'common';
export const cookieName = 'i18next';

// ----------------------------------------------------------------------

export function i18nOptions(lng = fallbackLng, ns = defaultNS) {
  return {
    // debug: true,
    lng,
    fallbackLng,
    ns: [defaultNS, 'errors'], // Preload errors namespace
    defaultNS,
    fallbackNS: defaultNS,
    supportedLngs: languages,
    preload: ['en'], // Preload English as fallback
  };
}

// ----------------------------------------------------------------------

export const changeLangMessages = {
  en: {
    success: 'Language has been changed!',
    error: 'Error changing language!',
    loading: 'Loading...',
  },
  tr: {
    success: 'Dil değiştirildi!',
    error: 'Dil değiştirme hatası!',
    loading: 'Yükleniyor...',
  },
  vi: {
    success: 'Ngôn ngữ đã được thay đổi!',
    error: 'Lỗi khi thay đổi ngôn ngữ!',
    loading: 'Đang tải...',
  },
  fr: {
    success: 'La langue a été changée!',
    error: 'Erreur lors du changement de langue!',
    loading: 'Chargement...',
  },
  cn: {
    success: '语言已更改！',
    error: '更改语言时出错！',
    loading: '加载中...',
  },
  ar: {
    success: 'تم تغيير اللغة!',
    error: 'خطأ في تغيير اللغة!',
    loading: 'جارٍ التحميل...',
  },
};
